/** FNV-1a: a small stable hash for picking looks deterministically (same name, same storefront). */
export const hash = (s: string) => { let h = 2166136261; for (let i = 0; i < s.length; i++) h = Math.imul(h ^ s.charCodeAt(i), 16777619); return h >>> 0; };
